import React from 'react';
import Text from 'Components/Text';
import moment from 'moment';
import { INSPECTION_STATUS } from 'constants/index';

export default function GeneralInformation({submittedBy, submissionDate, status, approvalDate}) {
  submissionDate = moment(submissionDate).local(true);

  submissionDate = submissionDate.isValid() ? submissionDate.format('MM / DD / YYYY') : 'MM / DD / YYYY';

  return (
    <section className='scene_section _padding_top_0'>
      <header>General Info</header>
      <Text
        mainWrapperClassName='text__wrapper_primary _margin_right_30'
        textClassName='text__text_primary'
        label='Variation Date'
        value={submissionDate}
      />
      <Text
        mainWrapperClassName='text__wrapper_primary'
        textClassName='text__text_primary'
        label='Submitted By'
        value={submittedBy ? `${submittedBy.firstName} ${submittedBy.lastName}` : 'N/A'}
      />
      {status === INSPECTION_STATUS.COMPLETE && (
        <Text
          mainWrapperClassName='text__wrapper_primary  _width_pc_100'
          textClassName='text__text_primary'
          label='Approval date'
          value={approvalDate ? moment(approvalDate).local(true).format('MM / DD / YYYY') : 'N/A'}
        />
      )}
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/Details/Response/GeneralInformation.jsx